const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const highlightMarkerSafe = (value: string, color = "#FF8040"): string => {
  const reg = /\{(.+?)\}/g;
  return escapeHtml(value).replace(reg, (match, content) => {
    return `<span style='color: ${color};'>${content}</span>`;
  });
};

export const highlightMarkerV2 = (searchValue: string): string => {
  return searchValue.replace(new RegExp("{([^}]+)}", "gi"), '<span class="highlight">$1</span>');
};

